import React, {useContext} from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExport, faFilter } from '@fortawesome/free-solid-svg-icons';
import {format, parse} from 'date-fns';
import { LabelText } from '../../components/Language';
import {AuditContext} from '../context/AuditProvider';
import { getSelectedContractIds } from '../../common/utility/utility';
import './index.css';

const exportTooltip = (
  <Tooltip id="exportIcon">
    <LabelText tid="export" />
  </Tooltip>
)

function AuditOverviewHeader(props) {  
    const { overview, isBtnExportEnable, handlerOnExportToExcelClick, overviewFilterData, 
    isOverviewFilterApplied, handlerOnClearFilterClick } = useContext(AuditContext); 
    const isExportAllowed = props.fromRevenueDate && props.untilRevenueDate && isBtnExportEnable && props.isValidDateRange;
    const onExportToExcelClick = () => {
      const request = {
          AuditStartDate: format(parse(props.fromRevenueDate, "dd/MM/yyyy", new Date()),"MM/dd/yyyy" ),
          AuditEndDate: format(parse(props.untilRevenueDate, "dd/MM/yyyy", new Date()),"MM/dd/yyyy" ),
          ContractIds: getSelectedContractIds(overviewFilterData && overviewFilterData.length > 0 ? overviewFilterData : overview)
      }
      handlerOnExportToExcelClick(request);
    }

    const clearFilterTooltip = (
      <Tooltip id="clearFilterIcon">
          <LabelText tid={isOverviewFilterApplied ? "clearfilter" : "inactivefilter"} />
      </Tooltip>
    )

    return (       
      <> 
        <OverlayTrigger placement="bottom" overlay={exportTooltip}>
          <div role="button" tabIndex="0" title="Export to excel button"
               disabled={!isExportAllowed} onClick={(ev)=> isExportAllowed ? onExportToExcelClick() : undefined}
               onKeyDown={(e) => { if (isExportAllowed && e.key === "Enter") onExportToExcelClick()}} >
            <FontAwesomeIcon className={isExportAllowed ? "ExportButton" :
             "ExportButton disable-icon" } icon= {faFileExport} />
          </div>
        </OverlayTrigger>  
        <OverlayTrigger placement="bottom" overlay={clearFilterTooltip}>
          <div role="button" tabIndex="0" 
              title= {isOverviewFilterApplied ? "Clear filter" : "Inactive Filter"}              
              disabled={!props.isOverviewDataAvailable}
              onClick={()=>isOverviewFilterApplied && handlerOnClearFilterClick(true, true)}
              onKeyDown={(e) => { e.key === "Enter" 
              && isOverviewFilterApplied && handlerOnClearFilterClick(true, true)}} >
              <FontAwesomeIcon className = { props.isOverviewDataAvailable ?
                  isOverviewFilterApplied ? "FilterButton ActiveFilterButton" 
                  : "FilterButton InActiveFilterButton"
                  : "FilterButton InActiveFilterButton disable-icon" } icon= {faFilter} />
          </div>
        </OverlayTrigger> 
      </>          
    )
}

export default AuditOverviewHeader;